module.exports = __webpack_public_path__ + "img/newyonghu.69c1c5cb.webp";